webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Client__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_pages_Login__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ClientOrder__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Production__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Commandes__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Clients__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_ClientEdit__ = __webpack_require__(176);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/client',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    meta: { auth: true, label: 'Accueil' },
    children: [{
      path: '/client',
      name: 'Client',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Client__["a" /* default */],
      meta: { auth: true }
    }, {
      path: '/order/:id/:orderid',
      name: 'Commande client',
      meta: { auth: true },
      component: __WEBPACK_IMPORTED_MODULE_5__views_ClientOrder__["a" /* default */]
    }, {
      path: '/production',
      name: 'Liste des items à produire',
      meta: { auth: true },
      component: __WEBPACK_IMPORTED_MODULE_6__views_Production__["a" /* default */]
    }, {
      path: '/listing',
      name: 'Liste des commandes',
      meta: { auth: true },
      component: __WEBPACK_IMPORTED_MODULE_7__views_Commandes__["a" /* default */]
    }, {
      path: '/clients',
      name: 'Liste des clients',
      meta: { auth: true },
      component: __WEBPACK_IMPORTED_MODULE_8__views_Clients__["a" /* default */]
    }, {
      path: '/client-edit/:id',
      name: 'Edition de client',
      meta: { auth: true },
      component: __WEBPACK_IMPORTED_MODULE_9__views_ClientEdit__["a" /* default */]
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__views_pages_Login__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/logout',
    name: 'logout',
    beforeEnter: function beforeEnter(to, from, next) {
      var v = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
      v.$eventHub.$emit('redirectToLogin');
      next(false);
    },
    meta: { auth: false }
  }]
}));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ls__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_ls___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  isLogged: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('token', 'unauth') !== 'unauth'
};

var mutations = {
  LOGIN_USER: function LOGIN_USER(state) {
    state.isLogged = true;
  },
  LOGOUT_USER: function LOGOUT_USER(state) {
    state.isLogged = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  state: state,
  mutations: mutations
}));

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vue", function() { return vue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progressbar__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ls__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notification__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(5);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_ls___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_progressbar___default.a, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = "https://part-tain.domaine-de-limagne.com/api";

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  var token = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].ls.get('token', 'unauth');
  if (token !== 'unauth') {
    request.headers.set('Authorization', 'Bearer ' + token);
  } else {
    console.log('NO token');
  }
  request.headers.set('X-B2N', 'yes');
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

var vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  },
  mounted: function mounted() {
    this.$eventHub.$on('redirectToLogin', this.redirectToLogin);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$off('redirectToLogin');
  },
  methods: {
    redirectToLogin: function redirectToLogin() {
      this.$ls.remove('token');
      __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('LOGOUT_USER');
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].go({ name: 'login' });
    }
  }
});

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8399f25c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(59)
  __webpack_require__(61)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8399f25c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);





__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.auth) {
    if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mounted: function mounted() {
    this.$nextTick(function () {
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/auth/check', this.data).then(function (response) {}, function (response) {
        if (response.status === 403) {
          console.log('nextTick trigger redirect to login');
        }
      });
    });
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c4d85d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(126);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c4d85d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(66);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Sidebar */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Client',
    url: '/client',
    icon: 'icon-people'
  }, {
    name: 'Production',
    url: '/production',
    icon: 'icon-wallet'
  }, {
    name: 'Commandes',
    url: '/listing',
    icon: 'icon-people'
  }, {
    name: 'Clients',
    url: '/clients',
    icon: 'icon-list'
  }, {
    name: 'Déconnexion',
    url: '/logout',
    icon: 'icon-logout'
  }]
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Callout_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Switch_vue__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */









/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dbf866_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(69);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dbf866_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cf8554_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(72);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cf8554_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b80bb336_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(75);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b80bb336_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_vm._v("\n  © 2017 "),_c('a',{attrs:{"href":"https://part.domaine-de-limagne.com"}},[_vm._v("Domaine de Limagne")]),_vm._v(".\n")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75a6eb52_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(78);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75a6eb52_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_vm._v("☰")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f815bafc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f815bafc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__(119);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2235186_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(84);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2235186_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a414e734_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(87);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a414e734_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fbe89a2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(90);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fbe89a2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b1453c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(93);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b1453c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728ef8a2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(96);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728ef8a2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cae6c8b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(100);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cae6c8b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d433117_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(118);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d433117_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb00324_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(121);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb00324_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9ab37e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(125);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9ab37e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Client_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_820c1eaa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Client_vue__ = __webpack_require__(137);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Client_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_820c1eaa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Client_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);








var customerResult = {
  template: '<tr><td style="cursor: pointer" v-on:click="$emit(\'edit\', customer.id )"><i class="fa fa-edit"/></td><td>{{ customer.email }}</td><td>{{ customer.name }}</td><td>{{ customer.surname }}</td><td>{{ customer.landline }} / {{ customer.gsm }}</td><td>{{ customer.street }} {{ customer.cp }} {{ customer.town }}</td><td style="cursor: pointer" v-on:click="$emit(\'order\', customer.id )"><i class="fa fa-shopping-cart"/></td></tr>',
  props: ['customer']
};

var orderPerCustomerResult = {
  template: '<tr><td>{{ order.id }}</td><td>{{ order.delivery }}</td><td>{{ order.goods_nb }}</td><td style="cursor: pointer" v-on:click="$emit(\'select\', order.id )"><i class="fa fa-shopping-cart"/></td><td style="cursor: pointer" v-on:click="$emit(\'print\', order.id )"><i class="fa fa-print"/></td></tr>',
  props: ['order']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'client',
  components: {
    'customer-row': customerResult,
    'order-row': orderPerCustomerResult
  },
  data: function data() {
    return {
      lastClientNb: 40,
      data: {
        id: 0,
        name: '',
        surname: '',
        email: '',
        gsm: '',
        landline: '',
        street: '',
        cp: undefined,
        town: '',
        comment: ''
      },
      orderID: '',
      isSearched: false,
      createBtnEnabled: true,
      saveBtnEnabled: false,
      showModalError: false,
      showCustomerOrders: false,
      customerOrderList: [],
      lastError: '',
      loadingSpinner: true,
      activeCustomerName: '',
      displayedCustomerName: '',
      customers: [],
      card: {
        title: 'Recherche/Création Client'
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    }
  },
  created: function created() {
    this.fetchLastCustomers();
  },

  watch: {
    data: {
      handler: function handler() {
        this.change();
      },
      deep: true
    }
  },
  methods: {
    fetchLastCustomers: function fetchLastCustomers() {
      var _this = this;

      this.createBtnEnabled = false;
      this.$Progress.start();
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/lasts', { params: { last: this.lastClientNb } }).then(function (response) {
        _this.customers = [];
        _this.customers = response.body.Customers;
        _this.$Progress.finish();
        _this.createBtnEnabled = true;
        _this.saveBtnEnabled = false;
        _this.card.title = 'Recherche/Création Client';
      }, function (error) {
        if (error.status === 403) {
          _this.$eventHub.$emit('redirectToLogin');
        } else {
          _this.createBtnEnabled = true;
          _this.saveBtnEnabled = false;
          _this.$Progress.fail();
          _this.customers = [];
          _this.lastError = error.body;
          if (error.status !== 404) {
            _this.showModalError = true;
          }
        }
      });
    },
    create: function create() {
      var _this2 = this;

      this.createBtnEnabled = false;
      this.$Progress.start();
      this.$http.post("https://part-tain.domaine-de-limagne.com/api" + '/customer/create', this.data).then(function (response) {
        _this2.customers = [];
        _this2.customers.push(response.body);
        _this2.$Progress.finish();
        _this2.createBtnEnabled = true;
        _this2.saveBtnEnabled = false;
        _this2.card.title = 'Recherche/Création Client';
      }, function (error) {
        _this2.createBtnEnabled = true;
        _this2.saveBtnEnabled = false;
        _this2.$Progress.fail();
        _this2.customers = [];
        _this2.lastError = error.body;
        _this2.showModalError = true;
      });
    },
    reset: function reset() {
      console.log('reset');
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.createBtnEnabled = true;
      this.saveBtnEnabled = false;
    },

    change: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
      var _this3 = this;

      this.$Progress.start();
      var req = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data);
      req.limit = this.lastClientNb;
      this.isSearched = true;
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/search', { params: req }).then(function (response) {
        _this3.customers = response.body.Customers;
        _this3.$Progress.finish();
      }, function (error) {
        _this3.$Progress.fail();
        _this3.customers = [];
        if (error.status === 403) {
          _this3.$eventHub.$emit('redirectToLogin');
        }
      });
    }, 500),
    doOrder: function doOrder(orderId) {
      var id = this.activeCustomerName;
      console.log('do order for id ' + id + ' / ' + orderId);
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Commande client', params: { id: id, orderid: orderId } });
    },
    doPrint: function doPrint(orderId) {
      var _this4 = this;

      this.$Progress.start();
      var id = this.activeCustomerName;
      console.log('do print for id ' + id + ' / ' + orderId);
      var req = { id: orderId };
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/order/print', { params: req, responseType: 'arraybuffer' }).then(function (response) {
        var base64EncodedPDF = response.body;
        _this4.src = base64EncodedPDF;
        _this4.$Progress.finish();
        _this4.printOrder();
      });
    },
    listOrders: function listOrders(id) {
      var _this5 = this;

      console.log('do list order for id ' + id);

      this.showCustomerOrders = true;
      this.customerOrderList = '';
      this.$Progress.start();
      this.createBtnEnabled = false;
      this.saveBtnEnabled = false;
      this.loadingSpinner = true;
      this.activeCustomerName = id;
      this.displayedCustomerName = '';
      for (var i = 0; i < this.customers.length; i++) {
        if (this.customers[i].id === id) {
          this.displayedCustomerName = this.customers[i].name;
          break;
        }
      }
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/get-orders', { params: { 'id': id } }).then(function (response) {
        _this5.loadingSpinner = false;
        _this5.$Progress.finish();
        _this5.createBtnEnabled = false;
        _this5.saveBtnEnabled = true;

        _this5.customerOrderList = [];
        for (var i = 0; i < response.body.orders.length; i++) {
          var order = { id: response.body.orders[i].order_id };

          order.goods_nb = response.body.orders[i].goods_nb;

          order.goods_ref_nb = response.body.orders[i].goods_ref_nb;

          order.delivery = response.body.orders[i].delivery;
          _this5.customerOrderList.push(order);
        }
      }, function (error) {
        _this5.createBtnEnabled = true;
        _this5.saveBtnEnabled = false;
        _this5.$Progress.fail();
        if (error.status === 403) {
          _this5.$eventHub.$emit('redirectToLogin');
        }
      });
    },
    edit: function edit(id) {
      console.log('do edit customer for id ' + id);

      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Edition de client', params: { id: id } });
    },
    openOrder: function openOrder() {
      var _this6 = this;

      if (this.orderID >= 1) {
        console.log('open Order ' + this.orderID);
        this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/order/get-customerid', { params: { 'id': this.orderID } }).then(function (response) {
          var customerID = response.body.id;
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Commande client', params: { id: customerID, orderid: _this6.orderID } });
        }, function (error) {
          _this6.$Progress.fail();
          if (error.status === 403) {
            _this6.$eventHub.$emit('redirectToLogin');
          }
        });
      }
    },
    printOrder: function printOrder() {
      console.log('print clients');
      var base64EncodedPDF = this.src;
      var downloadLink = document.createElement('a');

      downloadLink.download = 'commande.pdf';

      var blob = new Blob([base64EncodedPDF], { type: 'application/pdf' });

      var URL = window.URL || window.webkitURL;
      var downloadUrl = URL.createObjectURL(blob);

      downloadLink.href = downloadUrl;

      document.body.append(downloadLink);

      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
    }
  }
});

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.card.title))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-fieldset',{attrs:{"label":"Nom"}},[_c('b-form-input',{attrs:{"type":"text","id":"surname","autofocus":""},model:{value:(_vm.data.surname),callback:function ($$v) {_vm.data.surname=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.surname"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-fieldset',{attrs:{"label":"Prénom"}},[_c('b-form-input',{attrs:{"type":"text","id":"name"},model:{value:(_vm.data.name),callback:function ($$v) {_vm.data.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('b-form-fieldset',{attrs:{"label":"Fixe"}},[_c('b-form-input',{attrs:{"type":"text","id":"tel_fixe"},model:{value:(_vm.data.landline),callback:function ($$v) {_vm.data.landline=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.landline"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('b-form-fieldset',{attrs:{"label":"Mobile"}},[_c('b-form-input',{attrs:{"type":"text","id":"tel_mobile"},model:{value:(_vm.data.gsm),callback:function ($$v) {_vm.data.gsm=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.gsm"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('b-form-fieldset',{attrs:{"label":"Adresse"}},[_c('b-form-input',{attrs:{"type":"text","id":"address"},model:{value:(_vm.data.street),callback:function ($$v) {_vm.data.street=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.street"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('b-form-fieldset',{attrs:{"label":"CP"}},[_c('b-form-input',{attrs:{"type":"number","id":"postal","placeholder":"63000"},model:{value:(_vm.data.cp),callback:function ($$v) {_vm.data.cp=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.cp"}},[_vm._v(_vm._s(_vm.data.cp))])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-fieldset',{attrs:{"label":"Ville"}},[_c('b-form-input',{attrs:{"type":"text","id":"town"},model:{value:(_vm.data.town),callback:function ($$v) {_vm.data.town=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.town"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('b-form-fieldset',{attrs:{"label":"e-mail"}},[_c('b-form-input',{attrs:{"type":"email","id":"email"},model:{value:(_vm.data.email),callback:function ($$v) {_vm.data.email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('b-form-fieldset',{attrs:{"label":"Commentaire"}},[_c('b-form-input',{attrs:{"type":"text","id":"comment"},model:{value:(_vm.data.comment),callback:function ($$v) {_vm.data.comment=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.comment"}})],1)],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"success","disabled":! _vm.createBtnEnabled},on:{"click":_vm.create}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Créer un client")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"success","disabled":! _vm.saveBtnEnabled},on:{"click":_vm.create}},[_c('i',{staticClass:"fa fa-edit-o"}),_vm._v(" Sauvegarder les modifications")]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","size":"sm","variant":"danger"},on:{"click":_vm.reset}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Réinitialiser")])],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_c('div',{staticClass:"row"},[_c('span',[_vm._v("Numéro de commande ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.orderID),expression:"orderID",modifiers:{"trim":true}}],attrs:{"type":"text","id":"cmdid"},domProps:{"value":(_vm.orderID)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.openOrder($event)},"input":function($event){if($event.target.composing){ return; }_vm.orderID=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_c('span',[_vm._v(" ")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"success"},on:{"click":_vm.openOrder}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Accéder à une commande")])],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',{attrs:{"header":"Résultats de la recherche"}},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("e-mail")]),_vm._v(" "),_c('th',[_vm._v("Prénom")]),_vm._v(" "),_c('th',[_vm._v("Nom")]),_vm._v(" "),_c('th',[_vm._v("Tel fixe/mobile")]),_vm._v(" "),_c('th',[_vm._v("Adresse")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.customers),function(customer){return _c("customer-row",{key:customer.id,tag:"tr",attrs:{"customer":customer},on:{"order":_vm.listOrders,"edit":_vm.edit}})}))])])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"size":"lg","ok-only":""},model:{value:(_vm.showModalError),callback:function ($$v) {_vm.showModalError=$$v},expression:"showModalError"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.lastError)}})]),_vm._v(" "),_c('b-modal',{attrs:{"size":"lg","ok-only":"","ok-title":"Fermer"},model:{value:(_vm.showCustomerOrders),callback:function ($$v) {_vm.showCustomerOrders=$$v},expression:"showCustomerOrders"}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_c('strong',[_vm._v("Commandes en cours du client "+_vm._s(_vm.activeCustomerName)+" - "+_vm._s(_vm.displayedCustomerName))])]),_vm._v(" "),_c('b-card',{attrs:{"header":"Commandes en cours"}},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Numéro de commande")]),_vm._v(" "),_c('th',[_vm._v("Date de mise à disposition")]),_vm._v(" "),_c('th',[_vm._v("Nombre de produits")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.customerOrderList),function(order){return _c("order-row",{key:order.id,tag:"tr",attrs:{"order":order},on:{"select":_vm.doOrder,"print":_vm.doPrint}})}))])]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"success"},on:{"click":function($event){_vm.doOrder(0)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Créer une nouvelle commande client")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f76722e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(140);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f76722e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      context: 'login',
      redirect: '/',
      data: {
        body: { username: '', password: '' },
        rememberMe: false
      },
      error: false
    };
  },
  methods: {
    login: function login() {
      var _this = this;

      this.$Progress.start();
      this.error = false;
      this.$http.post("https://part-tain.domaine-de-limagne.com/api" + '/auth/login', this.data).then(function (response) {
        _this.loader = false;
        _this.$ls.set('token', response.body.meta.token);
        console.log('token: ' + _this.$ls.get('token') + ' vs ' + response.body.meta.token);
        _this.$http.headers.common['Authorization'] = 'Bearer ' + _this.$ls.get('token');
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGIN_USER');
        console.log('token stored');
        _this.$Progress.finish();
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
      }, function () {
        _this.error = true;
        _this.loader = false;
        _this.password = '';
        _this.$Progress.fail();
        _this.$ls.remove('token');
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGOUT_USER');
      });
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Authentification")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Authentification requise")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_vm._v("Identifiant ou mot de passe non valide")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.data.body.username),expression:"data.body.username",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","autofocus":"","placeholder":"identifiant","name":"username"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.data.body.username=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.data.body.password),expression:"data.body.password",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Mot de passe","name":"password"},domProps:{"value":(_vm.data.body.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.data.body.password=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":_vm.login}},[_vm._v("S'identifier")])]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_vm._m(3)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-link px-0",attrs:{"type":"button"}},[_vm._v("Mot de passe oublié ?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-white bg-primary py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('h2',[_vm._v("Pas d'identifiant")]),_vm._v(" "),_c('p',[_vm._v("Si vous n'avez pas reçu vos identifiants rapprochez vous de contact [@] domaine-de-limagne.com")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientOrder_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e99893_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientOrder_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e99893_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientOrder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_autocomplete_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_autocomplete_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_autocomplete_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);









var orderComponent = {
  template: '<tr><td>{{ row.ref }}</td><td>{{ row.name }}</td><td>{{ row.container }}</td><td>{{ row.quantity }}</td><td>{{ row.unite }}</td><td style="cursor: pointer" v-on:click="$emit(\'del\', row.ref )"><i class="fa fa-trash-o"/></td></tr>',
  props: ['row']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'clientOrder',
  components: {
    'order-row': orderComponent,
    autocomplete: __WEBPACK_IMPORTED_MODULE_4_vue2_autocomplete_js___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      data: {
        ref: '',
        name: '',
        quantity: 1,
        unit_price: 0.0,
        container: 'vrac',
        unite: 'piece'
      },
      client: {
        name: '',
        surname: '',
        lastOrder: 'nouvelle commande',
        saisiepar: ''
      },
      order: {
        label: '',
        comment: '',
        deliveryDate: new Date()
      },
      orderRows: [],
      searchedRefs: [],
      searchedProduct: [],
      createBtnEnabled: false,
      showModalError: false,
      showModalValidation: false,
      showModalDelete: false,
      showModalLeave: false,
      lastError: '',
      deleteBtnEnabled: false,
      notBeforeNow: { to: new Date() },
      orderModified: false,
      optionsContainer: [{ value: 'vrac', text: 'Vrac' }, { value: 'sous-vide', text: 'Sous-Vide' }],
      optionsUnite: [{ value: 'piece', text: 'Pièce' }, { value: 'kg', text: 'Kg' }]
    };
  },
  watch: {
    order: {
      handler: function handler() {
        if (this.orderRows.length > 0) {
          this.onOrderModified();
          this.deleteBtnEnabled = true;
        }
      },
      deep: true
    }
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go({ name: 'login' });
    }
  },
  created: function created() {
    this.fetchData();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log('beforeRouteUpdate');
    if (this.orderModified) {
      var answer = window.confirm('La commande n\'a pas été validée. Quittez ?');
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

  methods: {
    handleValidate: function handleValidate() {
      this.showModalValidation = false;
      console.log('ok');
      this.realValidateOrder();
    },
    handleDelete: function handleDelete() {
      this.showModalDelete = false;
      console.log('delete');
      this.realDeleteOrder();
    },
    handleLeave: function handleLeave() {
      this.showModalLeave = false;
    },
    onOrderModified: function onOrderModified() {
      this.createBtnEnabled = true;
      this.orderModified = true;
      console.log('order modified');
    },
    getDataRef: function getDataRef(obj) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('searching for good called ' + obj);
        _this.$Progress.start();
        _this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/goods/search', { params: { 'ref': obj } }).then(function (response) {
          _this.$Progress.finish();
          console.log(response.body);
          if (response.body.length === 1) {
            console.log('only one answer: ' + response.body[0].ref);
            _this.$refs.idref.setValue(response.body[0].ref);
            _this.$refs.descref.setValue(response.body[0].name);
            _this.data.ref = response.body[0].ref;
            _this.data.name = response.body[0].name;
          }
          resolve(response.body);
        }, function (error) {
          console.log('ref search failed ' + error.status);
          if (error.status === 403) {
            _this.$eventHub.$emit('redirectToLogin');
          }
          reject(new Error('ref search failed'));
        });
      });
    },
    autoSelect: function autoSelect(obj) {
      console.log('selected ' + obj.ref);
      this.$refs.idref.setValue(obj.ref);
      this.$refs.descref.setValue(obj.name);
      obj.container = 'vrac';
      obj.unite = 'piece';
      obj.quantity = 1;
      this.data = obj;
    },
    addRef: function addRef() {
      var qty = this.data.quantity;
      console.log('addRef ' + this.data.ref + ' ' + qty);
      if (this.data.quantity > 0 && this.data.name !== '' && this.data.ref !== '') {
        var modified = false;
        for (var i = 0; i < this.orderRows.length && !modified; i++) {
          if (this.orderRows[i].ref === this.data.ref && this.orderRows[i].container === this.data.container) {
            modified = true;
            this.orderRows.splice(i, 1, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data));
          }
        }
        if (!modified) {
          this.orderRows.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data));
        }

        this.data.ref = '';
        this.data.name = '';
        this.data.quantity = 1.0;
        this.data.unit_price = 0.0;
        this.$refs.idref.setValue('');
        this.$refs.descref.setValue('');
        this.createBtnEnabled = true;
      } else {
        console.log('addRef ' + this.data.ref + ' ignored');
      }
    },
    fetchData: function fetchData() {
      var _this2 = this;

      console.log('fetchData: ' + this.$route.params.id + ' / ' + this.$route.params.orderid);
      this.client.id = this.$route.params.id;
      if (parseInt(this.$route.params.orderid) === 0) {
        this.deleteBtnEnabled = false;
        this.order.comment = '';
        var now = new Date();
        var sprintf = __webpack_require__(161).sprintf;
        this.order.deliveryDate = sprintf('%d-%02d-%02d', now.getFullYear(), now.getMonth() + 1, now.getDate());
        console.log('fetchData: new order for ' + this.order.deliveryDate + ' (yes, a date)');
      } else {
        this.$Progress.start();
        console.log('fetchData / ' + this.client.id + ' / ' + this.$route.params.orderid);
        var orderReq = { 'client': this.client.id, 'order': this.$route.params.orderid };
        this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/order/get', { params: orderReq }).then(function (response) {
          _this2.$Progress.finish();
          console.log('response: ' + response.body);
          for (var i = 0; i < response.body.lines.length; i++) {
            _this2.orderRows.splice(i, 1, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, response.body.lines[i]));
          }
          _this2.client.lastOrder = response.body.order;
          _this2.client.saisiepar = ', saisie par ' + response.body.operator;
          console.log(response.body.delivery);
          _this2.order.deliveryDate = response.body.delivery;
          _this2.order.comment = response.body.comment;
          _this2.deleteBtnEnabled = _this2.client.lastOrder > 0;
          _this2.orderModified = false;
        }, function (error) {
          console.log('error on fetchData');
          _this2.$Progress.fail();
          if (error.status === 403) {
            _this2.$eventHub.$emit('redirectToLogin');
          }
        });
      }
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/get', { params: { 'id': this.client.id } }).then(function (response) {
        _this2.$Progress.finish();
        console.log('Order for ' + response.body.name + ' ' + response.body.surname);
        _this2.client.name = response.body.name;
        _this2.client.surname = response.body.surname;
      }, function () {
        _this2.$Progress.fail();
      });
    },
    delRow: function delRow(ref) {
      this.$Progress.start();
      var localOrder = [];
      console.log('del row: ' + ref);
      this.orderRows.forEach(function (row) {
        if (row.ref !== ref) {
          localOrder.push(row);
        }
      });
      this.orderRows = localOrder;
      this.$Progress.finish();
      this.createBtnEnabled = this.orderRows.length > 0;
    },
    backClientView: function backClientView() {
      this.orderModified = false;
      this.$router.push({ 'name': 'Client' });
    },
    validateOrder: function validateOrder() {
      this.showModalValidation = true;
      this.handleValidate();
    },
    deleteOrder: function deleteOrder() {
      this.showModalDelete = true;
      this.handleDelete();
    },
    realValidateOrder: function realValidateOrder() {
      var _this3 = this;

      this.createBtnEnabled = false;
      this.$Progress.start();
      var order = {};
      order.client = this.client.id;
      order.delivery = this.order.deliveryDate;
      order.comment = this.order.comment;
      var id = parseInt(this.$route.params.orderid);
      if (id > 0) {
        order.id = id;
      }
      order.rows = [];
      for (var i = 0; i < this.orderRows.length; i++) {
        order.rows.push(this.orderRows[i]);
      }
      console.log('creating order with ' + this.orderRows.length + ' lines (sending ' + order.rows.length + ')');
      this.$http.post("https://part-tain.domaine-de-limagne.com/api" + '/order/create', order).then(function (response) {
        _this3.$Progress.finish();
        _this3.createBtnEnabled = true;
        _this3.$notify({
          group: 'main',
          title: 'Commande client',
          text: 'La commande a bien été enregistrée sous le numéro ' + response.body.order_id + '.',
          duration: 5000
        });
        order.orderid = response.body.order_id;
        _this3.orderModified = false;
        _this3.$http.post("https://part-tain.domaine-de-limagne.com/api" + '/order/send-email', order).then(function (response2) {
          _this3.$Progress.finish();
          _this3.$notify({
            group: 'main',
            title: 'Commande client',
            text: 'Un mail de confirmation a été envoyé au client pour la commande ' + order.orderid + '.',
            duration: 5000
          });
        });
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'Client' });
      }, function (error) {
        _this3.$Progress.fail();
        _this3.createBtnEnabled = true;
        _this3.lastError = error.body;
        _this3.showModalError = true;
      });
    },
    realDeleteOrder: function realDeleteOrder() {
      var _this4 = this;

      var answer = window.confirm('Etes vous sûr de vouloir supprimer la commande ?');
      if (answer) {
        this.deleteBtnEnabled = false;
        this.$Progress.start();
        var order = {};
        order.client = this.client.id;
        order.orderId = this.client.lastOrder;
        console.log('delete order ' + order.client);
        this.$http.post("https://part-tain.domaine-de-limagne.com/api" + '/order/delete', order).then(function (response) {
          _this4.$Progress.finish();
          _this4.createBtnEnabled = true;
          _this4.$notify({
            group: 'main',
            title: 'Commande client ' + _this4.client.id,
            text: 'La commande a bien été supprimée.',
            duration: 2500
          });
          _this4.orderModified = false;
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'Client' });
        }, function (error) {
          _this4.$Progress.fail();
          _this4.deleteBtnEnabled = true;
          _this4.lastError = error.body;
          _this4.showModalError = true;
        });
      }
    }
  }
});

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.client.surname)+" "+_vm._s(_vm.client.name)+", client n° "+_vm._s(_vm.client.id)+" - "+_vm._s(_vm.client.lastOrder)+_vm._s(_vm.client.saisiepar))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("Entrer une référence produit ou un nom, et la quantité (elle remplace les quantités déjà saisies en cas de doublon)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('p',{staticClass:"align-text-bottom"},[_vm._v("Date de mise à disposition")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.order.deliveryDate),expression:"order.deliveryDate",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"date","autofocus":"","name":"datedemiseadispo"},domProps:{"value":(_vm.order.deliveryDate)},on:{"change":_vm.onOrderModified,"input":function($event){if($event.target.composing){ return; }_vm.order.deliveryDate=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 py-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.order.comment),expression:"order.comment",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"commentaire"},domProps:{"value":(_vm.order.comment)},on:{"change":_vm.onOrderModified,"input":function($event){if($event.target.composing){ return; }_vm.order.comment=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('autocomplete',{ref:"idref",attrs:{"url":"http://non-existent","anchor":"ref","label":"name","placeholder":"Réference","options":_vm.searchedRefs,"min":2,"debounce":200,"onSelect":_vm.autoSelect,"autofocus":true,"onShouldGetData":_vm.getDataRef}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('autocomplete',{ref:"descref",attrs:{"url":"http://non-existent","anchor":"name","label":"ref","placeholder":"Nom du produit","classes":{ input: 'col-md-12', wrapper: 'col-md-12', list: 'data-list col-md-12', item: 'data-list-item col-md-12' },"options":_vm.searchedProduct,"min":3,"debounce":200,"onSelect":_vm.autoSelect,"onShouldGetData":_vm.getDataRef}})],1),_vm._v(" "),_c('b-form-select',{ref:"container",staticClass:"col-md-1",attrs:{"required":"","options":_vm.optionsContainer},model:{value:(_vm.data.container),callback:function ($$v) {_vm.data.container=$$v},expression:"data.container"}}),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('b-form-input',{attrs:{"lang":"en-US","type":"number","step":".01","id":"qty","min":"0.0"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.addRef($event)}},model:{value:(_vm.data.quantity),callback:function ($$v) {_vm.data.quantity=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"data.quantity"}})],1),_vm._v(" "),_c('b-form-select',{ref:"unite",staticClass:"col-md-1",attrs:{"required":"","options":_vm.optionsUnite},model:{value:(_vm.data.unite),callback:function ($$v) {_vm.data.unite=$$v},expression:"data.unite"}}),_vm._v(" "),_c('div',{staticClass:"col-md-1 mx-auto"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"link"},on:{"click":_vm.addRef}},[_c('i',{staticClass:"fa fa-cart-plus"})])],1)],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Commande en cours "+_vm._s(_vm.order.label))])]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","disabled":! _vm.createBtnEnabled,"size":"sm","variant":"success"},on:{"click":_vm.validateOrder}},[_c('i',{staticClass:"fa fa-handshake-o"}),_vm._v(" Valider la commande")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","disabled":! _vm.deleteBtnEnabled,"size":"sm","variant":"warning"},on:{"click":_vm.deleteOrder}},[_c('i',{staticClass:"fa fa-eraser"}),_vm._v(" Supprimer la commande")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"error"},on:{"click":_vm.backClientView}},[_c('i',{staticClass:"fa fa-eraser"}),_vm._v(" Annuler les modifications")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v("ref")]),_vm._v(" "),_c('th',[_vm._v("Produit")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Qté")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.orderRows),function(row){return _c("order-row",{key:row.id,tag:"tr",attrs:{"row":row},on:{"del":_vm.delRow}})}))])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Production_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0636a299_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Production_vue__ = __webpack_require__(168);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Production_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0636a299_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Production_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);








var singleOrderRow = {
  template: '<tr><td>{{ item.ref }}</td><td>{{ item.name }}&nbsp;({{ item.container }})</td><td>{{ item.qty }} {{ item.unite }}</td></tr>',
  props: ['item']
};

var orderRow = {
  components: {
    'order-detailled-row': singleOrderRow
  },

  template: '<li><p class="col-md-12">{{ order.date }}</p>' + '<table class="table table-bordered table-striped table-sm">' + '<thead>' + '<tr>' + '<th style="width: 200px;">Ref</th>' + '<th >Intitulé</th>' + '<th style="width: 200px;">Qté</th>' + '</tr>' + '</thead>' + '<tbody>' + '<tr is="order-detailled-row" v-for="item in order.items" v-bind:key="order.id" v-bind:item="item"></tr>' + '</tbody>' + '</table>' + '</li>',
  props: ['order']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listing',
  components: {
    'order-row': orderRow,
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      plustext: 'Plus >>',
      consoleOutput: false,
      orders: [],
      totalPerRefs: [],
      showModalError: false,
      lastError: '',
      date: '',
      opened: [],
      displayDetailsModal: false,
      displaySpinner: true,
      detailRef: '',
      orderRangeStart: new Date(),
      orderRangeEnd: new Date(),
      rangeStart: new Date(),
      rangeEnd: new Date(),
      serverDate: '',
      orderHourStart: '',
      orderHourEnd: '',
      advancedSearch: false,
      cumulEnabled: false,
      readyForPrinting: false,
      src: ''
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    }
  },
  created: function created() {
    this.rangeEnd.setDate(this.rangeStart.getDate() + 7);
    this.orderHourEnd = this.rangeStart.getHours() + ':' + this.rangeStart.getMinutes();
  },

  watch: {
    orderRangeStart: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    orderRangeEnd: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    rangeStart: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    rangeEnd: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    orderHourStart: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    orderHourEnd: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    advancedSearch: {
      handler: function handler() {
        if (!this.advancedSearch) {
          this.plustext = 'Plus >>';
        } else {
          this.plustext = 'Moins <<';
        }
        this.onRangeModified();
      }
    }
  },
  methods: {
    onRangeModified: function onRangeModified() {
      this.fetchOrders();
    },
    fetchOrders: function fetchOrders() {
      var _this = this;

      this.$Progress.start();
      var req = { from: this.rangeStart.toJSON(), to: this.rangeEnd.toJSON() };
      if (this.advancedSearch && this.orderHourStart !== '') {
        req.orderRangeStart = this.orderRangeStart.toJSON();
        req.orderRangeEnd = this.orderRangeEnd.toJSON();
        req.orderHourStart = this.orderHourStart;
        req.orderHourEnd = this.orderHourEnd;
      }
      this.orders = [];
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/orders/get-by-product', { params: req }).then(function (response) {
        var orderList = response.body.list;
        _this.serverDate = response.body.date;
        if (_this.consoleOutput) {
          console.log('got ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(orderList).length);
        }
        var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(orderList);
        var totalRefs = [];
        for (var d in dates) {
          var fullre = dates[d];

          var order = { date: fullre, items: [] };
          if (_this.consoleOutput) {
            console.log('date: ' + order.date);
          }
          var refs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(orderList[fullre]);
          for (var r in refs) {
            if (_this.consoleOutput) {
              console.log('ref: ' + r);
            }
            for (var container in orderList[fullre][refs[r]].quantity) {
              if (_this.consoleOutput) {
                console.log('container: ' + container);
              }
              for (var u in orderList[fullre][refs[r]].quantity[container]) {
                if (_this.consoleOutput) {
                  console.log('unite: ' + u);
                }
                var localRef = { ref: refs[r], name: orderList[fullre][refs[r]].name, qty: orderList[fullre][refs[r]].quantity[container][u], container: container, unite: u };
                if (_this.consoleOutput) {
                  console.log(localRef.ref + ': ' + localRef.qty + ' items (' + localRef.name + '), container: ' + container + ', unite: ' + u);
                }
                order.items.push(localRef);
                if (typeof totalRefs[refs[r]] === 'undefined') {
                  totalRefs[refs[r]] = [];
                }
                if (typeof totalRefs[refs[r]][container] === 'undefined') {
                  totalRefs[refs[r]][container] = [];
                }
                if (typeof totalRefs[refs[r]][container][u] === 'undefined') {
                  totalRefs[refs[r]][container][u] = { qty: 0, desc: localRef.name };
                }
                totalRefs[refs[r]][container][u].qty += localRef.qty;
                console.log('qty total for ' + refs[r] + '/' + container + ' is now: ' + totalRefs[refs[r]][container][u].qty);
              }
            }
          }
          _this.orders.push(order);
        }
        _this.totalPerRefs = [];
        _this.totalPerRefs = totalRefs;
        _this.$Progress.finish();
      }, function (error) {
        _this.$Progress.fail();
        _this.orders = [];
        _this.totalPerRefs = [];
        if (error.status === 403) {
          _this.$eventHub.$emit('redirectToLogin');
        }
      });
      this.$Progress.start();

      req.format = 'pdf';
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/orders/get-by-product', { params: req, responseType: 'arraybuffer' }).then(function (response) {
        var base64EncodedPDF = response.body;
        _this.src_normal = base64EncodedPDF;
        _this.$Progress.finish();
      }, function (error) {
        console.log(error);
        _this.$Progress.fail();
      });
      this.$Progress.start();

      req.format = 'pdf';
      req.cumul = 1;
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/orders/get-by-product', { params: req, responseType: 'arraybuffer' }).then(function (response) {
        var base64EncodedPDF = response.body;
        _this.src_cumul = base64EncodedPDF;
        _this.readyForPrinting = true;
        _this.$Progress.finish();
      }, function (error) {
        console.log(error);
        _this.$Progress.fail();
      });
    },
    printOrders: function printOrders() {
      if (this.consoleOutput) {
        console.log('print orders');
      }
      var base64EncodedPDF = '';
      if (this.cumulEnabled) {
        base64EncodedPDF = this.src_cumul;
      } else {
        base64EncodedPDF = this.src_normal;
      }
      var downloadLink = document.createElement('a');

      downloadLink.download = 'production.pdf';

      var blob = new Blob([base64EncodedPDF], { type: 'application/pdf' });

      var URL = window.URL || window.webkitURL;
      var downloadUrl = URL.createObjectURL(blob);

      downloadLink.href = downloadUrl;

      document.body.append(downloadLink);

      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
    }
  }
});

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row d-flex"},[_c('strong',{attrs:{"size":"md"}},[_vm._v("Retrait de commande entre le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr"},model:{value:(_vm.rangeStart),callback:function ($$v) {_vm.rangeStart=$$v},expression:"rangeStart"}}),_vm._v(" "),_c('strong',[_vm._v(" et le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr"},model:{value:(_vm.rangeEnd),callback:function ($$v) {_vm.rangeEnd=$$v},expression:"rangeEnd"}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-1"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.advanced",modifiers:{"advanced":true}}],staticClass:"col-md-1",attrs:{"variant":"link"}},[_vm._v(_vm._s(_vm.plustext))]),_vm._v(" "),_c('b-collapse',{staticClass:"col-md-12",attrs:{"id":"advanced"},model:{value:(_vm.advancedSearch),callback:function ($$v) {_vm.advancedSearch=$$v},expression:"advancedSearch"}},[_c('div',{staticClass:"row mt-2"},[_c('strong',{staticClass:"col-md-3"},[_vm._v("Prise de commande entre le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr","bootstrapStyling":true},model:{value:(_vm.orderRangeStart),callback:function ($$v) {_vm.orderRangeStart=$$v},expression:"orderRangeStart"}}),_vm._v(" "),_c('b-form-input',{staticClass:"col-md-2",attrs:{"type":"time","size":"sm"},model:{value:(_vm.orderHourStart),callback:function ($$v) {_vm.orderHourStart=$$v},expression:"orderHourStart"}}),_vm._v(" "),_c('strong',[_vm._v(" et le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr","bootstrapStyling":true},model:{value:(_vm.orderRangeEnd),callback:function ($$v) {_vm.orderRangeEnd=$$v},expression:"orderRangeEnd"}}),_vm._v(" "),_c('b-form-input',{staticClass:"col-md-2",attrs:{"type":"time","size":"sm"},model:{value:(_vm.orderHourEnd),callback:function ($$v) {_vm.orderHourEnd=$$v},expression:"orderHourEnd"}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('b-form-checkbox',{attrs:{"id":"cumul"},model:{value:(_vm.cumulEnabled),callback:function ($$v) {_vm.cumulEnabled=$$v},expression:"cumulEnabled"}},[_vm._v("\n              Faire un cumul de production par référence sur la période\n            ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"float-left"},[_vm._v("Etat au "+_vm._s(_vm.serverDate)+"\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"outline-success"},on:{"click":_vm.printOrders}},[_vm._v("\n          Imprimer\n        ")])],1)]),_vm._v(" "),(_vm.cumulEnabled)?_c('div',[_c('div',[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Ref")]),_vm._v(" "),_c('th',[_vm._v("Intitulé")]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Qté")])])]),_vm._v(" "),_c('tbody',[_vm._l((Object.keys(_vm.totalPerRefs)),function(ref){return [_vm._l((Object.keys(_vm.totalPerRefs[ref])),function(container){return _vm._l((Object.keys(_vm.totalPerRefs[ref][container])),function(u){return _c('tr',[_c('td',[_vm._v(_vm._s(ref))]),_c('td',[_vm._v(_vm._s(_vm.totalPerRefs[ref][container][u].desc)+" ("+_vm._s(container)+")")]),_c('td',[_vm._v(_vm._s(_vm.totalPerRefs[ref][container][u].qty)+" "+_vm._s(u))])])})})]})],2)])])]):_c('div',[_c('ul',_vm._l((_vm.orders),function(order){return _c("order-row",{tag:"li",attrs:{"order":order}})}))])]),_vm._v(" "),_c('b-modal',{attrs:{"size":"lg","ok-only":""},model:{value:(_vm.showModalError),callback:function ($$v) {_vm.showModalError=$$v},expression:"showModalError"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.lastError)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commandes_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415b1689_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Commandes_vue__ = __webpack_require__(171);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commandes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415b1689_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Commandes_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);








var singleOrderRow = {
  template: '<tr><td>{{ item.ref }}</td><td>{{ item.name }} ({{ item.container }})</td><td>{{ item.quantity }} {{ item.unit_type }}</td></tr>',
  props: ['item']
};

var singleDateOrderRow = {
  components: {
    'order-detailled-row': singleOrderRow
  },
  template: '<li class="row"><p class="col-md-12"><strong>{{ item.customer }}</strong>: commande numéro {{ item.order_id }}&nbsp;&nbsp;&nbsp;({{item.operator}})&nbsp;&nbsp;&nbsp;<i class="fa fa-print" style="cursor: pointer" v-on:click="$emit(\'print\', item.order_id )"/></p>' + '<p class="col-md-12"><strong>commentaire: {{ item.comment }}</strong></p>' + '<div class="col-md-12">' + '<table class="table table-bordered table-striped table-sm" style="width=100%;">' + '<thead>' + '<tr>' + '<th style="width: 200px;">Ref</th>' + '<th>Intitulé</th>' + '<th style="width: 200px;">Qté</th>' + '</tr>' + '</thead>' + '<tbody>' + '<tr is="order-detailled-row" v-for="item in item.lines" v-bind:item="item"></tr>' + '</tbody>' + '</table>' + '</div>' + '</li>',
  props: ['item']
};

var ordersRow = {
  components: {
    'order-row': singleDateOrderRow
  },

  template: '<li class="col-md-12"><p class="col-md-12">{{ order.date }}</p>' + '<ul class="col-md-12">' + '<li is="order-row" v-for="singleOrder in order.orders" v-bind:item="singleOrder" class="col-md-12" v-on:print="$emit(\'print\', singleOrder.order_id )">' + '</li></ul></li>',
  props: ['order']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listing',
  components: {
    'orders-row': ordersRow,
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      customerOrders: [],
      showModalError: false,
      lastError: '',
      date: '',
      opened: [],
      displayDetailsModal: false,
      displaySpinner: true,
      detailRef: '',
      rangeStart: new Date(),
      rangeEnd: new Date(),
      orderRangeStart: new Date(),
      orderRangeEnd: new Date(),
      serverDate: '',
      commandesCount: '0 commande',
      orderHourStart: '',
      orderHourEnd: '',
      advancedSearch: false,
      src: '',
      srcSingleOrder: '',
      readyForPrinting: false,
      outputConsoleLog: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    }
  },
  created: function created() {
    this.rangeEnd.setDate(this.rangeStart.getDate() + 7);
    this.orderHourEnd = this.rangeStart.getHours() + ':' + this.rangeStart.getMinutes();
    this.fetchOrders();
  },

  watch: {
    orderRangeStart: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    orderRangeEnd: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    rangeStart: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    rangeEnd: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    orderHourStart: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    orderHourEnd: {
      handler: function handler() {
        this.onRangeModified();
      }
    },
    advancedSearch: {
      handler: function handler() {
        this.onRangeModified();
      }
    }
  },
  methods: {
    onRangeModified: function onRangeModified() {
      this.fetchOrders();
    },
    fetchOrders: function fetchOrders() {
      var _this = this;

      this.$Progress.start();
      var req = { from: this.rangeStart.toISOString(), to: this.rangeEnd.toISOString() };
      if (this.advancedSearch) {
        req.orderRangeStart = this.orderRangeStart.toISOString();
        req.orderRangeEnd = this.orderRangeEnd.toISOString();
        req.orderHourStart = this.orderHourStart;
        req.orderHourEnd = this.orderHourEnd;
      }
      this.readyForPrinting = false;
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/orders/get-by-customer', { params: req }).then(function (response) {
        _this.customerOrders = [];
        var orderDate = response.body.list;
        _this.serverDate = response.body.date;
        console.log('got ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(orderDate).length);
        var orderCount = 0;
        for (var d in orderDate) {
          if (_this.outputConsoleLog) {
            console.log('date: ' + d);
          }
          var orders = [];
          for (var i in orderDate[d]) {
            var currentOrder = orderDate[d][i];
            if (_this.outputConsoleLog) {
              console.log('  customer: ' + currentOrder.customer.trim());
            }
            orders.push(currentOrder);
          }
          orders.sort(function (a, b) {
            return a.customer.localeCompare(b.customer);
          });
          _this.customerOrders.push({ 'order': { 'date': d, 'orders': orders } });
          orderCount += orders.length;
        }
        if (orderCount > 1) {
          _this.commandesCount = orderCount + ' commandes';
        } else {
          _this.commandesCount = orderCount + ' commande';
        }
        _this.$Progress.finish();
      }, function (error) {
        _this.$Progress.fail();
        _this.orders = [];
        if (error.status === 403) {
          _this.$eventHub.$emit('redirectToLogin');
        }
      });
      this.$Progress.start();

      req.format = 'pdf';
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/orders/get-by-customer', { params: req, responseType: 'arraybuffer' }).then(function (response) {
        var base64EncodedPDF = response.body;
        _this.src = base64EncodedPDF;
        _this.readyForPrinting = true;
        _this.$Progress.finish();
      }, function (error) {
        console.log(error);
        _this.$Progress.fail();
      });
    },
    printOrders: function printOrders() {
      console.log('print orders');
      var base64EncodedPDF = this.src;
      var downloadLink = document.createElement('a');

      downloadLink.download = 'commandes.pdf';

      var blob = new Blob([base64EncodedPDF], { type: 'application/pdf' });

      var URL = window.URL || window.webkitURL;
      var downloadUrl = URL.createObjectURL(blob);

      downloadLink.href = downloadUrl;

      document.body.append(downloadLink);

      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
    },
    doPrint: function doPrint(orderId) {
      var _this2 = this;

      this.$Progress.start();
      var id = this.activeCustomerName;
      console.log('do print for id ' + id + ' / ' + orderId);
      var req = { id: orderId };
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/order/print', { params: req, responseType: 'arraybuffer' }).then(function (response) {
        var base64EncodedPDF = response.body;
        _this2.srcSingleOrder = base64EncodedPDF;
        _this2.$Progress.finish();
        _this2.printSingleOrder(orderId);
      });
    },
    printSingleOrder: function printSingleOrder(id) {
      console.log('print clients');
      var base64EncodedPDF = this.srcSingleOrder;
      var downloadLink = document.createElement('a');

      downloadLink.download = 'commande_' + id + '.pdf';

      var blob = new Blob([base64EncodedPDF], { type: 'application/pdf' });

      var URL = window.URL || window.webkitURL;
      var downloadUrl = URL.createObjectURL(blob);

      downloadLink.href = downloadUrl;

      document.body.append(downloadLink);

      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row d-flex"},[_c('strong',{attrs:{"size":"md"}},[_vm._v("Retrait de commande entre le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr"},model:{value:(_vm.rangeStart),callback:function ($$v) {_vm.rangeStart=$$v},expression:"rangeStart"}}),_vm._v(" "),_c('strong',[_vm._v(" et le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr"},model:{value:(_vm.rangeEnd),callback:function ($$v) {_vm.rangeEnd=$$v},expression:"rangeEnd"}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-1"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.advanced",modifiers:{"advanced":true}}],staticClass:"col-md-1",attrs:{"variant":"link"}},[_vm._v("Plus >>")]),_vm._v(" "),_c('b-collapse',{staticClass:"col-md-12",attrs:{"id":"advanced"},model:{value:(_vm.advancedSearch),callback:function ($$v) {_vm.advancedSearch=$$v},expression:"advancedSearch"}},[_c('div',{staticClass:"row mt-2"},[_c('strong',{staticClass:"col-md-3"},[_vm._v("Prise de commande entre le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr","bootstrapStyling":true},model:{value:(_vm.orderRangeStart),callback:function ($$v) {_vm.orderRangeStart=$$v},expression:"orderRangeStart"}}),_vm._v(" "),_c('b-form-input',{staticClass:"col-md-2",attrs:{"type":"time","size":"sm"},model:{value:(_vm.orderHourStart),callback:function ($$v) {_vm.orderHourStart=$$v},expression:"orderHourStart"}}),_vm._v(" "),_c('strong',[_vm._v(" et le ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"dd/MM/yyyy","monday-first":true,"required":"","language":"fr","bootstrapStyling":true},model:{value:(_vm.orderRangeEnd),callback:function ($$v) {_vm.orderRangeEnd=$$v},expression:"orderRangeEnd"}}),_vm._v(" "),_c('b-form-input',{staticClass:"col-md-2",attrs:{"type":"time","size":"sm"},model:{value:(_vm.orderHourEnd),callback:function ($$v) {_vm.orderHourEnd=$$v},expression:"orderHourEnd"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"float-left"},[_vm._v("Etat au "+_vm._s(_vm.serverDate)+", "+_vm._s(_vm.commandesCount)+"\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":!_vm.readyForPrinting,"size":"sm","variant":"outline-success"},on:{"click":_vm.printOrders}},[_vm._v("\n          Imprimer\n        ")])],1)]),_vm._v(" "),_c('ul',_vm._l((_vm.customerOrders),function(order){return _c("orders-row",{tag:"li",staticClass:"row",attrs:{"order":order.order},on:{"print":_vm.doPrint}})}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23efc5d8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__(175);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23efc5d8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listing',
  data: function data() {
    return {
      consoleOutput: true,
      clients: [],
      showModalError: false,
      lastError: '',
      date: '',
      opened: [],
      displaySpinner: true,
      detailRef: '',
      readyForPrinting: false,
      src: ''
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    }
  },
  created: function created() {
    this.fetchClients();
  },

  methods: {
    onRangeModified: function onRangeModified() {
      this.fetchClients();
    },
    fetchClients: function fetchClients() {
      var _this = this;

      this.$Progress.start();
      this.clients = [];
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/list').then(function (response) {
        var clientList = response.body.Customers;
        _this.serverDate = response.body.date;
        if (_this.consoleOutput) {
          console.log('got ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(clientList).length + ' customers');
        }
        for (var c in clientList) {
          if (clientList[c].cp === 0) {
            clientList[c].cp = '';
          }
          _this.clients.push(clientList[c]);
        }
        _this.$Progress.finish();
      }, function (error) {
        _this.$Progress.fail();
        _this.clients = [];
        if (error.status === 403) {
          _this.$eventHub.$emit('redirectToLogin');
        }
      });
      this.$Progress.finish();
      this.$Progress.start();
    },
    printClients: function printClients() {
      if (this.consoleOutput) {
        console.log('print clients');
      }
      var base64EncodedPDF = this.src;
      var downloadLink = document.createElement('a');

      downloadLink.download = 'clients.pdf';

      var blob = new Blob([base64EncodedPDF], { type: 'application/pdf' });

      var URL = window.URL || window.webkitURL;
      var downloadUrl = URL.createObjectURL(blob);

      downloadLink.href = downloadUrl;

      document.body.append(downloadLink);

      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
    },
    removeCustomer: function removeCustomer(id, name) {
      var _this2 = this;

      this.$Progress.start();
      var req = { 'id': id };

      console.log('remove client ' + id);

      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/delete', { params: req }).then(function (response) {
        _this2.fetchClients();
        _this2.$notify({
          group: 'main',
          title: 'Suppression client',
          text: 'Client ' + id + ' supprimé.',
          duration: 5000
        });
        _this2.$Progress.finish();
      }, function (error) {
        console.log(error);
        _this2.$notify({
          group: 'main',
          title: 'Suppression client',
          text: 'Impossible de supprimer le client ' + id + ' (' + name + '), il est lié à une commande.',
          duration: 5000,
          type: 'error'
        });
        _this2.$Progress.fail();
      });
    },
    edit: function edit(id) {
      console.log('edit client ' + id);
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Edition de client', params: { id: id } });
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row d-flex"},[_c('strong',{attrs:{"size":"md"}},[_vm._v("Liste des clients")])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm",staticStyle:{}},[_c('thead',[_c('tr',[_c('th'),_c('th',[_vm._v("Nom")]),_c('th',[_vm._v("Prénom")]),_c('th',[_vm._v("Adresse")]),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.clients),function(client){return [_c('tr',[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.edit(client.id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.surname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.street)+" "+_vm._s(client.cp)+" "+_vm._s(client.town))]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.removeCustomer(client.id, client.surname)}}},[_c('i',{staticClass:"fa fa-trash-o"})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"3"}},[_vm._v(_vm._s(client.comment))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"2"}},[_vm._v(_vm._s(client.email)+" / "+_vm._s(client.landline)+" / "+_vm._s(client.gsm))]),_vm._v(" "),_c('td')])]})],2)])]),_vm._v(" "),_c('b-modal',{attrs:{"size":"lg","ok-only":""},model:{value:(_vm.showModalError),callback:function ($$v) {_vm.showModalError=$$v},expression:"showModalError"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.lastError)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientEdit_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63666c55_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientEdit_vue__ = __webpack_require__(178);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63666c55_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);







var singleOrderRow = {
  template: '<tr><td>{{ item.ref }}</td><td>{{ item.name }} ({{ item.container }})</td><td>{{ item.quantity }} {{ item.unit_type }}</td></tr>',
  props: ['item']
};

var singleDateOrderRow = {
  components: {
    'order-detailled-row': singleOrderRow
  },
  template: '<li class="row"><p class="col-md-12">commande numéro {{ item.order_id }}&nbsp;&nbsp;&nbsp;({{item.operator}})</p>' + '<p class="col-md-12"><strong>commentaire: {{ item.comment }}</strong></p>' + '<div class="col-md-12">' + '<table class="table table-bordered table-striped table-sm" style="width=100%;">' + '<thead>' + '<tr>' + '<th style="width: 200px;">Ref</th>' + '<th>Intitulé</th>' + '<th style="width: 200px;">Qté</th>' + '</tr>' + '</thead>' + '<tbody>' + '<tr is="order-detailled-row" v-for="item in item.lines" v-bind:item="item"></tr>' + '</tbody>' + '</table>' + '</div>' + '</li>',
  props: ['item']
};

var ordersRow = {
  components: {
    'order-row': singleDateOrderRow
  },

  template: '<li class="col-md-12"><p class="col-md-12">{{ order.date }}</p>' + '<ul class="col-md-12">' + '<li is="order-row" v-for="singleOrder in order.orders" v-bind:item="singleOrder" class="col-md-12" v-on:print="$emit(\'print\', singleOrder.order_id )">' + '</li></ul></li>',
  props: ['order']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'clientEdit',
  components: {
    'orders-row': ordersRow
  },
  data: function data() {
    return {
      client: {
        id: 0,
        name: '',
        surname: '',
        email: '',
        gsm: '',
        landline: '',
        street: '',
        cp: undefined,
        town: ''
      },
      saveBtnEnabled: true,
      lastError: '',
      loadingSpinner: true,
      activeCustomerName: '',
      displayedCustomerName: '',
      customerOrderList: '',
      customerOrders: [],
      card: {
        title: 'Edition de Client'
      },
      outputConsoleLog: true
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    }
  },
  created: function created() {
    this.client.id = this.$route.params.id;
    this.fetchCustomer();
    this.listOrders();
  },

  methods: {
    fetchCustomer: function fetchCustomer() {
      var _this = this;

      this.$Progress.start();
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/customer/get', { params: { 'id': this.client.id } }).then(function (response) {
        _this.$Progress.finish();
        _this.client = response.body;
      }, function (error) {
        console.log(error);
        _this.$Progress.fail();
      });
    },
    create: function create() {
      var _this2 = this;

      this.createBtnEnabled = false;
      this.$Progress.start();
      this.$http.post("https://part-tain.domaine-de-limagne.com/api" + '/customer/create', this.client).then(function (response) {
        _this2.$Progress.finish();
        _this2.saveBtnEnabled = false;
      }, function (error) {
        _this2.saveBtnEnabled = false;
        _this2.$Progress.fail();
        console.log(error);
      });
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(-1);
    },
    listOrders: function listOrders() {
      var _this3 = this;

      console.log('do list order for id ' + this.client.id);
      this.$Progress.start();
      this.$http.get("https://part-tain.domaine-de-limagne.com/api" + '/orders/get-for-customer', { params: { 'id': this.client.id } }).then(function (response) {
        _this3.customerOrders = [];
        var orderDate = response.body.list;
        _this3.serverDate = response.body.date;
        if (_this3.outputConsoleLog) {
          console.log('got ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(orderDate).length);
        }
        var orderCount = 0;
        for (var d in orderDate) {
          if (_this3.outputConsoleLog) {
            console.log('date: ' + d);
          }
          var orders = [];
          for (var i in orderDate[d]) {
            var currentOrder = orderDate[d][i];
            orders.push(currentOrder);
          }
          _this3.customerOrders.push({ 'order': { 'date': d, 'orders': orders } });
          orderCount += orders.length;
        }
        if (orderCount > 1) {
          _this3.commandesCount = orderCount + ' commandes';
        } else {
          _this3.commandesCount = orderCount + ' commande';
        }
        _this3.$Progress.finish();
      }, function (error) {
        _this3.$Progress.fail();
        _this3.orders = [];
        if (error.status === 403) {
          _this3.$eventHub.$emit('redirectToLogin');
        }
      });
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.card.title))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-fieldset',{attrs:{"label":"Nom"}},[_c('b-form-input',{attrs:{"type":"text","id":"surname","autofocus":""},model:{value:(_vm.client.surname),callback:function ($$v) {_vm.client.surname=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.surname"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-fieldset',{attrs:{"label":"Prénom"}},[_c('b-form-input',{attrs:{"type":"text","id":"name"},model:{value:(_vm.client.name),callback:function ($$v) {_vm.client.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('b-form-fieldset',{attrs:{"label":"Fixe"}},[_c('b-form-input',{attrs:{"type":"text","id":"tel_fixe"},model:{value:(_vm.client.landline),callback:function ($$v) {_vm.client.landline=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.landline"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('b-form-fieldset',{attrs:{"label":"Mobile"}},[_c('b-form-input',{attrs:{"type":"text","id":"tel_mobile"},model:{value:(_vm.client.gsm),callback:function ($$v) {_vm.client.gsm=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.gsm"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('b-form-fieldset',{attrs:{"label":"Adresse"}},[_c('b-form-input',{attrs:{"type":"text","id":"address"},model:{value:(_vm.client.street),callback:function ($$v) {_vm.client.street=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.street"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('b-form-fieldset',{attrs:{"label":"CP"}},[_c('b-form-input',{attrs:{"type":"number","id":"postal","placeholder":"63000"},model:{value:(_vm.client.cp),callback:function ($$v) {_vm.client.cp=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.cp"}},[_vm._v(_vm._s(_vm.client.cp))])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-fieldset',{attrs:{"label":"Ville"}},[_c('b-form-input',{attrs:{"type":"text","id":"town"},model:{value:(_vm.client.town),callback:function ($$v) {_vm.client.town=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.town"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('b-form-fieldset',{attrs:{"label":"e-mail"}},[_c('b-form-input',{attrs:{"type":"email","id":"email"},model:{value:(_vm.client.email),callback:function ($$v) {_vm.client.email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('b-form-fieldset',{attrs:{"label":"Commentaire"}},[_c('b-form-input',{attrs:{"type":"text","id":"comment"},model:{value:(_vm.client.comment),callback:function ($$v) {_vm.client.comment=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"client.comment"}})],1)],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"success","disabled":! _vm.saveBtnEnabled},on:{"click":_vm.create}},[_c('i',{staticClass:"fa fa-edit-o"}),_vm._v(" Sauvegarder les modifications")]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","size":"sm","variant":"danger"},on:{"click":_vm.close}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Fermer")])],1)]),_vm._v(" "),_c('b-card',{attrs:{"header":"Commandes"}},[_c('ul',_vm._l((_vm.customerOrders),function(order){return _c("orders-row",{tag:"li",staticClass:"row",attrs:{"order":order.order}})}))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('vue-progress-bar'),_vm._v(" "),_c('notifications',{attrs:{"group":"main"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[54]);


// WEBPACK FOOTER //
// static/js/app.80e2dbe45da10173dd99.js